export const UPDATE_SITE_POSITION = "UPDATE_SITE_POSITION";
export const UPDATE_SHOW_BUTTONS = "UPDATE_SHOW_BUTTONS";

export const UpdateSitePosition = (val) => {
    return (dispatch, getState) => {
        dispatch({
            type: UPDATE_SITE_POSITION,
            value: val
        });

        setTimeout(() => {
            dispatch({
                type: UPDATE_SHOW_BUTTONS
            });
        }, 1500);
    };
};

export const moveSitePosition = (direction) => {
    return (dispatch, getState) => {
        let num = getState().navBar.sitePosition;
        if (direction == "up") {
            num = num + 100;
        }
        if (direction == "down") {
            num = num - 100;
        }

        dispatch({
            type: UPDATE_SITE_POSITION,
            value: num
        });

        setTimeout(() => {
            dispatch({
                type: UPDATE_SHOW_BUTTONS
            });
        }, 1500);
    };
};
